export const TerminalWithTitle = {
  extends: 'Group',
  Title: {
    tag: 'title',
  },
  Terminal: {},
};